import MainHeader from '../../components/mainHeader/Index.vue'
import MainFooter from '../../components/mainFooter/Index.vue'
import Dict from '../../components/dict/Index.vue'
import { getProfile } from '../../api/talent'
import config from "@/config"
import { getWeb3,tokenAmountShow,tokenAmountSend,_getGasPrice } from '../../utils/web3'
import { Icon } from '@iconify/vue2'
export default {
  components: { MainHeader, MainFooter, Dict, Icon },
  data(){
    return{
      profile: null,
      currentAccount:null,
      tips: {
        metaMaskTips: "",
        accountBtnTips: "",
      },
      loadings: {
        mintLoading:false,
        metaMaskLoading: false,
      },
      viewed:0,
      earned:0,
      walletInit:false
    }
  },
  filters:{
    formatLookingFor(param){
      return param.join('/')
    }
  },
  created(){
    
  },
  watch: {
    currentAccount: {
      handler(newVal, oldVal){
        if(newVal != oldVal){
          this.queryProfile()
        }
      }
    }
  },
  methods:{
    toRouter(path){
      let id = null
      if(this.profile)
        id= this.profile.id
      this.$router.push({name:path,query:{id:id}})
    },
    queryProfile(){
      const that = this
      if(this.currentAccount != null){
        getProfile(this.currentAccount).then((resp) => {
          that.profile = resp.data
        });
        that.walletInit = false
        that.queryTokenInfo()
      }else{
        that.profile = null
      }
    },
    async queryTokenInfo() {
      const web3 = await getWeb3()
      const connextAppContract = new web3.eth.Contract(config.connextAppABI, config.connextAppAddress)
      const amountForClaimResult =await connextAppContract.methods.amountForClaim(this.currentAccount).call()
      this.earned = tokenAmountShow(amountForClaimResult)
      const viewedCountResult = await connextAppContract.methods.viewedCount(this.currentAccount).call()
      this.viewed = viewedCountResult
      this.walletInit = true
    },
    async doClaim(event){
      const target = event.currentTarget
      if(event.currentTarget.disabled)
        return
      event.currentTarget.disabled=true
      const loading = this.$loading({
        target: event.currentTarget,
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const that = this

      if(that.earned<=0){
        this.$message({
          showClose: true,
          message: 'Earned Token is 0!',
          type: 'warning'
        })
        target.disabled=false
        loading.close();
        return
      }
      
      const web3 = await getWeb3()
      let amountToSend = tokenAmountSend(that.earned)
      const connextAppContract = new web3.eth.Contract(config.connextAppABI, config.connextAppAddress)
      // let checkResult = await _checkApproval2(that.currentAccount, that.currentAccount, amountToSend);
      // if(!checkResult){
      //   console.log(checkResult);
      //   target.disabled=false
      //   loading.close();
      //   return;
      // }

      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then(async() => {
          connextAppContract.methods.claim(that.currentAccount, amountToSend).send({ from: that.currentAccount, gasPrice: web3.utils.toWei(await _getGasPrice(), 'gwei')})
          .on('transactionHash', function(hash){
            console.log(hash)
          })
          .on('confirmation', function(confirmationNumber, receipt){
            if(confirmationNumber === 1) {
              console.log(receipt)
              target.disabled=false
              loading.close();
              that.queryTokenInfo()
            }
          })
          .on('receipt', function(receipt){
            console.log(receipt)
          })
          .on('error', function(error) {
            target.disabled=false
            loading.close();
            console.log(error)
          })
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'warning'
          })

          target.disabled=false
          loading.close();
        })

      
    }
  }
};